<template>
  <v-btn
    class="comments px-0"
    :disabled="!inChat"
    icon
    @click="$emit('action')">
    <sBadge
      v-if="inChat && hasUnreaded"
      color="pink"
      data-qa="comments-btn-badge"
      dot/>
    <sIcon
      class="mr-2"
      type="comment"/>
    <span class="body-2 mt-">{{ comments_length }} </span>
  </v-btn>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'commentsCountBtn',
  props: {
    comments_length: Number,
    chat: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  created() {
    if (this.chat && this.chat.messages) {
      this.chat.messages.forEach(el => el.time = moment(el.timeStamp).add(3, 'hours').format())
    }
  },
  computed: {
    ...mapGetters({
      user: 'GET_USER'
    }),
    user_id() {
      return this.user?.purchasingSettings?.userId?.trim()
    },
    inChat() {
      if (!this.chat || !this.chat.chatUsers) { return }
      let chatUser = this.chat.chatUsers.find(x => {
        return x.user?.id == this.user_id
      })
      return !!chatUser
    },
    hasUnreaded() {
      if (!this.chat || !this.chat.chatUsers) { return }
      let chatUser = this.chat.chatUsers.find(x => {
        return x.user?.id == this.user_id
      })

      let lastVisit = chatUser ? chatUser.lastVisit : ''
      let messages = this.chat.messages
      let result = messages.some(x => {
        return ((Date.parse(x.time) > Date.parse(lastVisit)) && (x.user?.id != this.user_id))
      })
      return result
    }
  },
}
</script>
<style lang="scss" scoped>

.comments {
  // width: 100px;
  // position: absolute;
  // right: 14px;
  // bottom: 0px;
   span {
    height: 16px;
    color: var(--black-color);
  }
  .v-btn--disabled{
    opacity: 0.5;
  }
}
</style>
